import { useTypedSelector } from '@k3/core'
import { useThree } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'
import { useVerandaSelector } from '../..'
import { LedSpot } from '../utility/light/LedSpot'

const glowYellow = new THREE.MeshStandardMaterial({
  color: new THREE.Color(7, 4, 0.5),
  toneMapped: false,
})

export const HouseLight = ({
  lightsOn,
}: {
  lightsOn?: boolean
}): JSX.Element => {
  const box = new THREE.BoxGeometry(0.085, 0.06, 0.075)
  const { scene } = useThree()
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)

  const groupRef = useRef<THREE.Group>(null)

  const positions = [] as THREE.Vector3[]
  const targets = [] as THREE.Object3D[]
  scene.traverse((child) => {
    if (child?.userData?.glowsAtNight || child?.name == 'GlowLamp') {
      positions.push(child.getWorldPosition(new THREE.Vector3()))
      targets.push(new THREE.Object3D())
    }
  })

  return (
    <group ref={groupRef}>
      {positions.map((position, index) => (
        <group
          key={'LightPosition' + index}
          position={groupRef.current?.worldToLocal(position)}
        >
          {lightsOn && (
            <>
              <primitive position={[0, -1, 0]} object={targets[index]} />
              <spotLight
                position={[0, 0.1, 0]}
                rotation={[0, 30, 0]}
                penumbra={0.25}
                target={targets[index]}
                castShadow={false}
                color={glowYellow.color}
                intensity={nightMode ? 0.85 : 0.0001}
                distance={3}
              />
            </>
          )}

          <LedSpot
            geometry={box}
            position={[0, 0.25, 0]}
            material={glowYellow}
            visible={nightMode}
          />
        </group>
      ))}
    </group>
  )
}
